var locale = {
  locale: 'us',
  more: 'More',
  custom: 'Custom',
  inputPlaceHolder: 'Please enter text'
};
export default locale;